import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/home",
    name: "home",
    component: HomeView,
  },
  //一般向け
  {
    path: "/general/",
    name: "generalIndex",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/general/Index.vue"),
  },
  {
    path: "/general/:id",
    name: "generalDetail",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/general/Detail.vue"),
  },
  //ドクター向け
  {
    path: "/doctor/",
    name: "clinicIndex",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/doctor/Index.vue"),
  },
  {
    path: "/doctor/:id",
    name: "doctorDetail",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/doctor/Detail.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
